import { render, staticRenderFns } from "./PopupConfirmDeletion.vue?vue&type=template&id=2cd9cd12&scoped=true&"
import script from "./PopupConfirmDeletion.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirmDeletion.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirmDeletion.vue?vue&type=style&index=0&id=2cd9cd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9cd12",
  null
  
)

export default component.exports